function getLink(address: string) {
    return "https://google.ca/maps/place/" + address;
}

export default getLink; 